import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Divider } from '@mui/material';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export const SearchBox = ({ formik, handleDownExcel }) => {
    const [searchStrtDt, setSearchStrtDt] = useState(null);
    const [searchEndDt, setSearchEndDt] = useState(null);

    useEffect(() => {
        if (formik.values.searchStrtDt) {
            setSearchStrtDt(dayjs(formik.values.searchStrtDt));
        }
        if (formik.values.searchEndDt) {
            setSearchEndDt(dayjs(formik.values.searchEndDt));
        }
    }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
                mx: 1
            }}
            onSubmit={formik.handleSubmit}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DatePicker
                            label="매출 시작일"
                            format="YYYY-MM-DD"
                            mask={'____-__-__'}
                            id="searchStrtDt"
                            name="searchStrtDt"
                            value={dayjs(searchStrtDt)}
                            onChange={(newValue) => {
                                setSearchStrtDt(dayjs(newValue));
                                onChangeDate(dayjs(newValue), 'searchStrtDt');
                            }}
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                                error:
                                  formik.touched.searchStrtDt &&
                                        Boolean(formik.errors.searchStrtDt),
                                helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                              },
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ mx: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DatePicker
                            label="매출 종료일"
                            format="YYYY-MM-DD"
                            mask={'____-__-__'}
                            id="searchEndDt"
                            name="searchEndDt"
                            value={dayjs(searchEndDt)}
                            onChange={(newValue) => {
                                setSearchEndDt(dayjs(newValue));
                                onChangeDate(dayjs(newValue), 'searchEndDt');
                            }}
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                                error:
                                  formik.touched.searchEndDt &&
                                        Boolean(formik.errors.searchEndDt),
                                helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                              },
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ ml: 2 }}>
                    <Button
                        type="submit"
                        color="info"
                        variant="contained"
                        disabled={formik.isSubmitting}
                    >
                        검색
                    </Button>
                </Box>
                <Box sx={{ mx: 1 }}>
                    <Button
                        type="button"
                        color="success"
                        variant="contained"
                        onClick={handleDownExcel}
                    >
                        엑셀 다운로드
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
